import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row, Tab, ToggleButton } from "react-bootstrap";
import { IoMdArrowBack, IoMdArrowForward, IoMdTime } from "react-icons/io";
import { CiLocationOn } from "react-icons/ci";
import { FaArrowRightLong } from "react-icons/fa6";
import FileUpload from "../../../Components/FileUpload";
import CircleStepNavigation from "../../../Components/CircleStepNavigation";
// import ScrollToTop from "../../../Components/ScrollToTop";

const JobApplication = () => {
    let navigate = useNavigate();

    let [chooseOptionView, setChooseOptionView] = useState(false);
    let [currentStep, setCurrentStep] = useState(1);

    let goToStepTabForm = () => {
        setChooseOptionView(true);
        setCurrentStep(1);
    }

    // let autoFillWithResume = () => {
    //     setChooseOptionView(true);
    //     setCurrentStep(1);
    // }

    // let manualEntry = () => {
    //     setChooseOptionView(true);
    //     setCurrentStep(2);
    // }

    let [candidateQ1RadioValue, setCandidateQ1RadioValue] = useState('');
    let [candidateQ2RadioValue, setCandidateQ2RadioValue] = useState('');
    let [candidateQ4RadioValue, setCandidateQ4RadioValue] = useState('');

    let [wasValidate, setwasValidate] = useState(false);

    // disabling form submissions if there are invalid fields
    const formValidation = () => {
        'use strict'
        setwasValidate(true);
    }

    return ( <>
    {/* <ScrollToTop watch={goToStepTabForm} /> */}
    <div className="job-application single-page">
        {/* Banner */}
        <section className="hero-banner d-flex flex-column align-items-stretch justify-content-center pb-4 pb-lg-0">

            <div className="container-lg pb-4 h-100">
                <Row className="align-items-center h-100 position-relative">
                    <Col>
                        <IoMdArrowBack size={20} role="button" onClick={()=> navigate('/careers/job-description')} />
                    </Col>
                    <Col xl={7} className="mx-auto text-center">
                        <div data-aos="fade-up">
                            <div className="hstack gap-2 justify-content-center">
                                <span className="badge lh-sm text-bg-light">New</span>
                                <span className="badge lh-sm text-body border">Onsite</span>
                            </div>
                            <h1 className="fw-semibold display-5 banner-title">Senior Software Engineer</h1>
                            <p className="mb-3 h5 text-secondary fw-medium lead lh-base">
                                Engineering
                            </p>
                            {/* <p className="mt-3 mb-4 h5 text-secondary lead lh-base">
                                Full-time | Remote (USA timezones)
                            </p> */}
                            <div className="hstack gap-3 justify-content-center">
                                <div className="d-flex align-items-center text-secondary">
                                    <CiLocationOn size={20} />
                                    <span className="ps-1 fw-semibold">Coimbatore</span>
                                </div>
                                <div className="d-flex align-items-center text-secondary">
                                    <IoMdTime size={20} />
                                    <span className="ps-1 fw-semibold">Full-Time</span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col></Col>
                </Row>
            </div>

        </section>
        {/* // Banner END // */}

        {/* Application Choose Option */}
        {!chooseOptionView && (
            <section className="container-fluid py-5 bg-body-tertiary bg-opacity-50">
                <Row>
                    <Col md={10} lg={8} xl={6} xxl={4} className="mx-auto">
                        <div className="mb-3 text-center">
                            <h4 className="fw-bold">How would you like to apply?</h4>
                            <div className="h6 text-secondary">Choose the fastest path for you</div>
                        </div>
                        <div className="vstack gap-3">
                            <Card body role="button" onClick={goToStepTabForm}>
                                <div className="hstack justify-content-between icon-link icon-link-hover">
                                    <div className="vstack">
                                        <div className="fw-bold">Autofill with Resume</div>
                                        <div className="text-secondary">Upload your resume and we’ll extract the details</div>
                                    </div>
                                    <FaArrowRightLong size={18} className="bi stretched-link" />
                                </div>
                            </Card>
                            <Card body role="button" onClick={goToStepTabForm}>
                                <div className="hstack justify-content-between icon-link icon-link-hover">
                                    <div className="vstack">
                                        <div className="fw-bold">Manual Entry</div>
                                        <div className="text-secondary">Fill in your details step by step</div>
                                    </div>
                                    <FaArrowRightLong size={18} className="bi stretched-link" />
                                </div>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </section>
        )}
        {/* // Application Choose Option END // */}
        {/* // Application Step Form END // */}
        {chooseOptionView && (
        <section className="container-fluid py-5 bg-body-tertiary bg-opacity-50">
            <Tab.Container activeKey={`step-${currentStep}`} onSelect={(k) => setCurrentStep(Number(k.split('-')[1]))}>
                <Row>
                    <Col lg={11} xl={10} xxl={9} className="mx-auto">
                        <CircleStepNavigation 
                            // disabledSteps={[2, 3, 4, 5]}
                            steps={['Resume', 'Contact Info', 'Experience', 'Candidate Form', 'Review & Submit']}
                            showLabels={true}
                            containerClassName="application-step-tab"
                            currentStep={currentStep}
                            onStepClick={setCurrentStep}
                        />
                        
                        <Tab.Content className="mt-2">
                            {/* Step 1 - Resume */}
                            {currentStep === 1 && (<Tab.Pane eventKey="step-1">
                                <Card border="light" className="mt-3 shadow-sm" style={{minHeight: 458}}>
                                    <Card.Header as={"h5"} className="bg-white border-0 fw-semibold">Resume</Card.Header>
                                    <Card.Body>
                                        {/* File Upload Section */}
                                        <div className="mb-4" data-aos="fade-down">
                                            <FileUpload />
                                        </div>
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-top-0 hstack justify-content-between">
                                        <Button variant="light" className="flat-btn" 
                                        onClick={()=> setChooseOptionView(false)}>
                                            Close
                                        </Button>
                                        <div className="hstack gap-2">
                                            <Button variant="outline-primary" onClick={()=> navigate('/careers/job-description')}>
                                                Save as Draft
                                            </Button>
                                            <Button variant="primary" onClick={() => setCurrentStep(2)}>
                                                Continue <IoMdArrowForward className="ms-2" />
                                            </Button>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            </Tab.Pane>)}
                            {/* // Step 1 - Resume // */}
                            {/* Step 2 - Contact Info */}
                            {currentStep === 2 && (<Tab.Pane eventKey="step-2">
                                <Card border="light" className="mt-3 shadow-sm" style={{minHeight: 458}}>
                                    <Card.Header as={"h5"} className="bg-white border-0 fw-semibold">Contact Information</Card.Header>
                                    <Card.Body>
                                        <Row className={`g-3 g-xl-4 needs-validation ${wasValidate ? 'was-validated' : ''}`}>
                                            <Col sm={6}>
                                                <Form.Group controlId="firstName" className="form-label-group in-border mb-0">
                                                    <Form.Control placeholder="Firstt Name" required />
                                                    <Form.Label>First name <span className="text-danger">&lowast;</span></Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group controlId="lastName" className="form-label-group in-border mb-0">
                                                    <Form.Control placeholder="Last Name" required />
                                                    <Form.Label>Last name <span className="text-danger">&lowast;</span></Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12}>
                                                <Form.Group controlId="email" className="form-label-group in-border mb-0">
                                                    <Form.Control type="email" placeholder="abc@email.com" required 
                                                    autoComplete="off" />
                                                    <Form.Label>Email <span className="text-danger">&lowast;</span></Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12}>
                                                <Form.Group controlId="phoneNumber" className="form-label-group in-border mb-0">
                                                    <span className="position-absolute h-100 p-2 ps-3 fs-14 d-flex align-items-center" 
                                                    id="inputGroupPrepend">+91</span>
                                                    <Form.Control type="tel" className="ps-5" placeholder="9876544321" 
                                                    aria-describedby="inputGroupPrepend" required />
                                                    <Form.Label className="ps-4 ms-4">Phone Number <span className="text-danger">&lowast;</span></Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12}>
                                                <Form.Group controlId="linkedInProfileUrl" className="form-label-group in-border mb-0">
                                                    <Form.Control type="url" placeholder="https://linkedin.com/in/yourprofile" />
                                                    <Form.Label>LinkedIn Profile</Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12}>
                                                <Form.Group controlId="address" className="form-label-group in-border mb-0">
                                                    <Form.Control as={"textarea"} rows={3} placeholder="Please type your Address" 
                                                    autoComplete="off" />
                                                    <Form.Label>Address Details</Form.Label>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-top-0 hstack justify-content-between">
                                        <Button variant="light" className="flat-btn" 
                                        onClick={()=> setChooseOptionView(false)}>
                                            Close
                                        </Button>
                                        <div className="hstack gap-2">
                                            <Button variant="outline-primary" onClick={()=> navigate('/careers/job-description')}>
                                                Save as Draft
                                            </Button>
                                            <Button variant="primary" onClick={() => {setCurrentStep(3); formValidation();}}>
                                                Continue <IoMdArrowForward className="ms-2" />
                                            </Button>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            </Tab.Pane>)}
                            {/* // Step 2 - Contact Info // */}
                            {/* Step 3 - Experience */}
                            {currentStep === 3 && (<Tab.Pane eventKey="step-3">
                                <Card border="light" className="mt-3 shadow-sm" style={{minHeight: 458}}>
                                    <Card.Header as={"h5"} className="bg-white border-0 fw-semibold">Experience</Card.Header>
                                    <Card.Body>
                                        <Form.Group controlId="currentCompany" className="form-label-group in-border">
                                            <Form.Control placeholder="Current Company" />
                                            <Form.Label>Current Company</Form.Label>
                                        </Form.Group>
                                        <Form.Group controlId="currentRole" className="form-label-group in-border">
                                            <Form.Control placeholder="Current Role" />
                                            <Form.Label>Current Role</Form.Label>
                                        </Form.Group>
                                        <Form.Group controlId="yearsOfExperience" className="form-label-group in-border">
                                            <Form.Control placeholder="Years Of Experience" />
                                            <Form.Label>Years Of Experience</Form.Label>
                                        </Form.Group>
                                        <Form.Group controlId="currentAnnualCtc" className="form-label-group in-border">
                                            <Form.Control placeholder="Current Annual CTC" />
                                            <Form.Label>Current Annual CTC</Form.Label>
                                        </Form.Group>
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-top-0 hstack justify-content-between">
                                        <Button variant="light" className="flat-btn" 
                                        onClick={()=> setChooseOptionView(false)}>
                                            Close
                                        </Button>
                                        <div className="hstack gap-2">
                                            <Button variant="outline-primary" onClick={()=> navigate('/careers/job-description')}>
                                                Save as Draft
                                            </Button>
                                            <Button variant="primary" onClick={() => setCurrentStep(4)}>
                                                Continue <IoMdArrowForward className="ms-2" />
                                            </Button>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            </Tab.Pane>)}
                            {/* // Step 3 - Experience // */}
                            {/* Step 4 - Candidate Form */}
                            {currentStep === 4 && (<Tab.Pane eventKey="step-4">
                                <Card border="light" className="mt-3 shadow-sm" style={{minHeight: 458}}>
                                    <Card.Header as={"h5"} className="bg-white border-0 fw-semibold">Candidate Form</Card.Header>
                                    <Card.Body>
                                        <Row xs={1} md={2} className="g-3">
                                            <Col>
                                                <Card body className="shadow-sm h-100">
                                                    <Card.Text className="text-secondary mb-2">
                                                        Question 1 <span className="text-danger">&lowast;</span>
                                                    </Card.Text>
                                                    <Card.Subtitle className="fw-semibold mb-2">
                                                        Are You Open To Relocate For This Role ?
                                                    </Card.Subtitle>
                                                    <div>
                                                        <ToggleButton
                                                            id={`candidate-q1-radio-1`}
                                                            type="radio"
                                                            variant="light mx-1"
                                                            name="candidate-q1-radio" 
                                                            value={'q1-radio-1'}
                                                            checked={candidateQ1RadioValue === 'q1-radio-1'}
                                                            onChange={(e) => setCandidateQ1RadioValue(e.currentTarget.value)}
                                                        >
                                                            Yes I’m Ready
                                                        </ToggleButton>
                                                        <ToggleButton
                                                            id={`candidate-q1-radio-2`}
                                                            type="radio"
                                                            variant="light mx-1"
                                                            name="candidate-q1-radio" 
                                                            value={'q1-radio-2'} 
                                                            checked={candidateQ1RadioValue === 'q1-radio-2'}
                                                            onChange={(e) => setCandidateQ1RadioValue(e.currentTarget.value)}
                                                        >
                                                            No, Prefer my Current City
                                                        </ToggleButton>
                                                    </div>
                                                </Card>
                                            </Col>
                                            <Col>
                                                <Card body className="shadow-sm h-100">
                                                    <Card.Text className="text-secondary mb-2">
                                                        Question 2 <span className="text-danger">&lowast;</span>
                                                    </Card.Text>
                                                    <Card.Subtitle className="fw-semibold mb-2">
                                                        Willingness To Travel ?
                                                    </Card.Subtitle>
                                                    <div>
                                                        <ToggleButton
                                                            id={`candidate-q2-radio-1`}
                                                            type="radio"
                                                            variant="light m-1"
                                                            name="candidate-q2-radio" 
                                                            value={'q2-radio-1'}
                                                            checked={candidateQ2RadioValue === 'q2-radio-1'}
                                                            onChange={(e) => setCandidateQ2RadioValue(e.currentTarget.value)}
                                                        >
                                                            Yes, Upto 25%
                                                        </ToggleButton>
                                                        <ToggleButton
                                                            id={`candidate-q2-radio-2`}
                                                            type="radio"
                                                            variant="light m-1"
                                                            name="candidate-q2-radio" 
                                                            value={'q2-radio-2'}
                                                            checked={candidateQ2RadioValue === 'q2-radio-2'}
                                                            onChange={(e) => setCandidateQ2RadioValue(e.currentTarget.value)}
                                                        >
                                                            Yes, I'm Willing
                                                        </ToggleButton>
                                                        <ToggleButton
                                                            id={`candidate-q2-radio-3`}
                                                            type="radio"
                                                            variant="light m-1"
                                                            name="candidate-q2-radio" 
                                                            value={'q2-radio-3'}
                                                            checked={candidateQ2RadioValue === 'q2-radio-3'}
                                                            onChange={(e) => setCandidateQ2RadioValue(e.currentTarget.value)}
                                                        >
                                                            No
                                                        </ToggleButton>
                                                    </div>
                                                </Card>
                                            </Col>
                                            <Col>
                                                <Card body className="shadow-sm h-100">
                                                    <Card.Text className="text-secondary mb-2">
                                                        Question 3 <span className="text-danger">&lowast;</span>
                                                    </Card.Text>
                                                    <Card.Subtitle className="fw-semibold mb-2">
                                                        Your Notice Period ?
                                                    </Card.Subtitle>
                                                    <Form.Group controlId="noticePeriod" className="mb-0">
                                                        <Form.Select defaultValue={'2 weeks'}>
                                                            <option value={''} disabled>Select</option>
                                                            <option value={'1 weeks'}>1 weeks</option>
                                                            <option value={'2 weeks'}>2 weeks</option>
                                                            <option value={'3 weeks'}>3 weeks</option>
                                                            <option value={'1 month'}>1 month</option>
                                                            <option value={'2 month'}>2 month</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Card>
                                            </Col>
                                            <Col>
                                                <Card body className="shadow-sm h-100">
                                                    <Card.Text className="text-secondary mb-2">
                                                        Question 4 <span className="text-danger">&lowast;</span>
                                                    </Card.Text>
                                                    <Card.Subtitle className="fw-semibold mb-2">
                                                        Preferred Work Mode ?
                                                    </Card.Subtitle>
                                                    <div>
                                                        <ToggleButton
                                                            id={`candidate-q4-radio-1`}
                                                            type="radio"
                                                            variant="light m-1"
                                                            name="candidate-q4-radio"
                                                            value={'q4-radio-1'}
                                                            checked={candidateQ4RadioValue === 'q4-radio-1'}
                                                            onChange={(e) => setCandidateQ4RadioValue(e.currentTarget.value)}
                                                        >
                                                            Onsite
                                                        </ToggleButton>
                                                        <ToggleButton
                                                            id={`candidate-q4-radio-2`}
                                                            type="radio"
                                                            variant="light m-1"
                                                            name="candidate-q4-radio"
                                                            value={'q4-radio-2'}
                                                            checked={candidateQ4RadioValue === 'q4-radio-2'}
                                                            onChange={(e) => setCandidateQ4RadioValue(e.currentTarget.value)}
                                                        >
                                                            Hybrid
                                                        </ToggleButton>
                                                        <ToggleButton
                                                            id={`candidate-q4-radio-3`}
                                                            type="radio"
                                                            variant="light m-1"
                                                            name="candidate-q4-radio"
                                                            value={'q4-radio-3'}
                                                            checked={candidateQ4RadioValue === 'q4-radio-3'}
                                                            onChange={(e) => setCandidateQ4RadioValue(e.currentTarget.value)}
                                                        >
                                                            Remote
                                                        </ToggleButton>
                                                    </div>
                                                </Card>
                                            </Col>
                                            <Col>
                                                <Card body className="shadow-sm h-100">
                                                    <Card.Text className="text-secondary mb-2">
                                                        Question 5
                                                    </Card.Text>
                                                    <Card.Subtitle className="fw-semibold mb-2">
                                                        Earliest Start Date ?
                                                    </Card.Subtitle>
                                                    <Form.Group controlId="earliestStartDate" className="mb-0">
                                                        <Form.Control type="date" placeholder="Choose Date" />
                                                    </Form.Group>
                                                </Card>
                                            </Col>
                                            <Col>
                                                <Card body className="shadow-sm h-100">
                                                    <Card.Text className="text-secondary mb-2">
                                                        Question 6 <span className="text-danger">&lowast;</span>
                                                    </Card.Text>
                                                    <Card.Subtitle className="fw-semibold mb-2">
                                                        Salary Expectation (USD) ?
                                                    </Card.Subtitle>
                                                    <Form.Group controlId="salaryExpectation" className="mb-0">
                                                        <Form.Control placeholder="Salary Expectation" />
                                                    </Form.Group>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-top-0 hstack justify-content-between">
                                        <Button variant="light" className="flat-btn" 
                                        onClick={()=> setChooseOptionView(false)}>
                                            Close
                                        </Button>
                                        <div className="hstack gap-2">
                                            <Button variant="outline-primary" onClick={()=> navigate('/careers/job-description')}>
                                                Save as Draft
                                            </Button>
                                            <Button variant="primary" onClick={() => setCurrentStep(5)}>
                                                Continue <IoMdArrowForward className="ms-2" />
                                            </Button>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            </Tab.Pane>)}
                            {/* // Step 4 - Candidate Form // */}
                            {/* Step 5 - Review & Submit */}
                            {currentStep === 5 && (<Tab.Pane eventKey="step-5">
                                <Card border="light" className="mt-3 shadow-sm" style={{minHeight: 458}}>
                                    <Card.Header as={"h5"} className="bg-white border-0 fw-semibold">Review & Submit</Card.Header>
                                    <Card.Body>
                                        <Card body border="0" style={{ "--bs-card-bg": "#F6F6FF" }}>
                                            <Card.Title as={"h6"} className="fw-semibold">Application Summary</Card.Title>
                                            <Row className="g-2">
                                                <Col sm={6} md={4} lg={3} className="text-secondary" style={{width: 200}}>Position :</Col>
                                                <Col sm={6} md={8} lg={9} className="text-dark fw-semibold">Senior Software Engineer</Col>
                                                <Col sm={6} md={4} lg={3} className="text-secondary" style={{width: 200}}>Name :</Col>
                                                <Col sm={6} md={8} lg={9} className="text-dark fw-semibold">Donald Trump</Col>
                                                <Col sm={6} md={4} lg={3} className="text-secondary" style={{width: 200}}>Email :</Col>
                                                <Col sm={6} md={8} lg={9} className="text-dark fw-semibold">abc@gmail.com</Col>
                                                <Col sm={6} md={4} lg={3} className="text-secondary" style={{ width: 200 }}>Phone :</Col>
                                                <Col sm={6} md={8} lg={9} className="text-dark fw-semibold">+91 0987654321</Col>
                                                <Col sm={6} md={4} lg={3} className="text-secondary" style={{width: 200}}>Experience :</Col>
                                                <Col sm={6} md={8} lg={9} className="text-dark fw-semibold">2 Years</Col>
                                                <Col sm={6} md={4} lg={3} className="text-secondary" style={{width: 200}}>Company :</Col>
                                                <Col sm={6} md={8} lg={9} className="text-dark fw-semibold">ABC Corporation</Col>
                                                <Col sm={6} md={4} lg={3} className="text-secondary" style={{width: 200}}>current CTC :</Col>
                                                <Col sm={6} md={8} lg={9} className="text-dark fw-semibold">10,00,000</Col>
                                            </Row>
                                        </Card>
                                        <h6 className="fw-semibold mt-3">Create Password to track your Application</h6>
                                        <Row className={`g-3 g-xl-4`}>
                                            <Col sm={6}>
                                                <Form.Group controlId="password" className="form-label-group in-border mb-0">
                                                    <Form.Control type="password" placeholder="Password" required autoComplete="new-password" />
                                                    <Form.Label>Password <span className="text-danger">&lowast;</span></Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group controlId="confirmPassword" className="form-label-group in-border mb-0">
                                                    <Form.Control type="password" placeholder="Confirm Password" required autoComplete="new-password" />
                                                    <Form.Label>Confirm Password <span className="text-danger">&lowast;</span></Form.Label>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-top-0 hstack justify-content-between">
                                        <Button variant="light" className="flat-btn" 
                                        onClick={()=> setChooseOptionView(false)}>
                                            Close
                                        </Button>
                                        <div className="hstack gap-2">
                                            <Button variant="success" onClick={()=> navigate('/candidate-dashboard')}>
                                                Submit Application
                                            </Button>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            </Tab.Pane>)}
                            {/* // Step 5 - Review & Submit // */}
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </section>
        )}
        {/* // Application Step Form END // */}

        {/* OLD Form Section 
        <div className="bg-white rounded-3 p-3 p-xl-4 pb-0" data-aos="fade-up">
            <h6 className="fw-semibold mb-4">General Deatails</h6>
            <form className={`row g-3 g-xl-4 needs-validation ${wasValidate ? 'was-validated':''}`}>
                <div className="col-sm-6">
                    <div className="form-label-group in-border mb-0">
                        <input type="text" className="form-control" id="validationCustom01" 
                        placeholder="Firstt Name" required />
                        <label htmlFor="validationCustom01" className="form-label">First name</label>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="form-label-group in-border mb-0">
                        <input type="text" className="form-control" id="validationCustom02" placeholder="Last Name" />
                        <label htmlFor="validationCustom02" className="form-label">Last name</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <input type="email" className="form-control" id="validationEmail" 
                        placeholder="mail@address.com" required />
                        <label htmlFor="validationEmail" className="form-label">Email</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <span className="position-absolute h-100 p-2 ps-3 fs-14 d-flex align-items-center" id="inputGroupPrepend">+91</span>
                        <input type="text" className="form-control ps-5" id="validationPhone" 
                        aria-describedby="inputGroupPrepend" placeholder="9008007000" required />
                        <label htmlFor="validationPhone" className="form-label ps-4 ms-4">Phone Number</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <input type="text" className="form-control" id="validationYog" 
                        placeholder="Year of Graduation" required />
                        <label htmlFor="validationYog" className="form-label">Year of Graduation</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <select className="form-select" 
                        id="selectedGenderId" name="selectedGender" defaultValue="placeholder" required>
                            <option value="placeholder" disabled>Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                        </select>
                        <label htmlFor="selectedGenderId" className="form-label">Gender</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <select className="form-select" 
                        id="selectedExpId" name="selectedExp" defaultValue="placeholder" required>
                            <option value="placeholder" disabled>Experience</option>
                            <option value="fresher">0 - 6 Months</option>
                            <option value="6months">6 months To 1 Year</option>
                            <option value="1to2years">1 To 2 Years</option>
                            <option value="2to3years">2 To 3 Years</option>
                            <option value="3to4years">3 To 4 Years</option>
                            <option value="5years">5+ Years</option>
                            <option value="6years">6+ Years</option>
                        </select>
                        <label htmlFor="selectedExpId" className="form-label">Experience</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <select className="form-select" 
                        id="selectedCurEmpId" name="selectedCurEmp" defaultValue="placeholder" required>
                            <option value="placeholder" disabled>Current Employer</option>
                            <option value="male">Yes</option>
                            <option value="female">No</option>
                        </select>
                        <label htmlFor="selectedCurEmpId" className="form-label">Current Employer</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <select className="form-select" 
                        id="selectedExCtcId" name="selectedExCtc" defaultValue="placeholder" required>
                            <option value="placeholder" disabled>Expected CTC</option>
                            <option value="1lakhs">1 Lakhs</option>
                            <option value="2lakhs">2 Lakhs</option>
                            <option value="3lakhs">3 Lakhs</option>
                            <option value="4lakhs">4 Lakhs</option>
                            <option value="6lakhs">6 Lakhs</option>
                            <option value="8lakhs">8 Lakhs</option>
                            <option value="10lakhs">10 Lakhs</option>
                        </select>
                        <label htmlFor="selectedExCtcId" className="form-label">Expected CTC</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <select className="form-select" 
                        id="selectedNotPeId" name="selectedNotPe" defaultValue="placeholder" required>
                            <option value="placeholder" disabled>Notice Period</option>
                            <option value="immediate">Immediate</option>
                            <option value="0t1mon">0 - 1 Month</option>
                            <option value="1t3mon">1 month To 3 months</option>
                        </select>
                        <label htmlFor="selectedNotPeId" className="form-label">Notice Period</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <textarea id="validationMsg" className="form-control text-bg-light" placeholder="Please type comma(,) separated" rows="4"></textarea>
                        <label htmlFor="validationMsg" className="form-label">Skill Set</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <select className="form-select" 
                        id="selectedCurLocId" name="selectedCurLoc" defaultValue="placeholder" required>
                            <option value="placeholder" disabled>Current Location</option>
                            <option value="coimbatore">Coimbatore</option>
                            <option value="chennai">Chennai</option>
                            <option value="madurai">Madurai</option>
                        </select>
                        <label htmlFor="selectedCurLocId" className="form-label">Current Location</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-label-group in-border mb-0">
                        <select className="form-select" 
                        id="selectedPreLocId" name="selectedPreLoc" defaultValue="placeholder" required>
                            <option value="placeholder" disabled>Preferred Location</option>
                            <option value="coimbatore">Coimbatore</option>
                            <option value="chennai">Chennai</option>
                            <option value="madurai">Madurai</option>
                        </select>
                        <label htmlFor="selectedPreLocId" className="form-label">Preferred Location</label>
                    </div>
                </div>

                <div className="col-12 text-center">
                    <Button variant="primary-digy" type="submit" size="lg" 
                        onClick={()=> formValidation()} className='fs-6 icon-link icon-link-hover'>
                        Apply
                        <IoMdArrowRoundForward className="bi fs-6 ms-1" />
                    </Button>
                </div>
            </form>
        </div>
        // // OLD Form Section // */}
    </div>
    </> );
}
 
export default JobApplication;